// src/NotFoundPage.js
import React, { useEffect } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import ReportProblemIcon from '@mui/icons-material/ReportProblem'; // Optional: an icon

function NotFoundPage() {
    useEffect(() => {
        document.title = 'SpinnerCS - Page Not Found';
    }, []);

    return (
        <Container maxWidth="sm" sx={{ mt: 8, mb: 4, textAlign: 'center' }}>
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    p: 4,
                    bgcolor: 'background.paper',
                    borderRadius: 2,
                    boxShadow: 3,
                }}
            >
                <ReportProblemIcon sx={{ fontSize: 80, color: 'warning.main', mb: 2 }} />
                <Typography variant="h3" component="h1" gutterBottom sx={{ fontWeight: 'bold' }}>
                    404
                </Typography>
                <Typography variant="h5" component="h2" color="text.secondary" gutterBottom>
                    Oops! Page Not Found.
                </Typography>
                <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
                    The page you are looking for might have been removed, had its name changed, or is temporarily unavailable.
                </Typography>
                <Button variant="contained" component={RouterLink} to="/" size="large">
                    Go to Homepage
                </Button>
            </Box>
        </Container>
    );
}

export default NotFoundPage;